import React, { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useParams } from "react-router-dom";
import { CarDataType } from "data/types";
import { getFleetsById } from "services/apiServices";
import FleetsreqCard from "./FleetsreqCard";

export interface FleetsRequestProps {
  className?: string;
  data?: CarDataType[];
}

type FleetsRequestLocationState = {
  fleetdata?: CarDataType[];
};

const FleetsRequest: FC<FleetsRequestProps> = ({ className = "" }) => {
  const location = useLocation();
  const { id } = useParams();
  const routeState = location.state as FleetsRequestLocationState | null;

  const [fleetsData, setFleetsData] = useState<CarDataType[]>(
    routeState?.fleetdata ?? []
  );

  useEffect(() => {
    if (routeState?.fleetdata?.length) {
      return;
    }

    const fetchFleetsData = async () => {
      if (!id) {
        return;
      }

      try {
        const response = await getFleetsById(id);
        if (response?.data?.response === "success") {
          setFleetsData(response.data.fleets ?? []);
        }
      } catch (error) {
        console.error("Failed to fetch fleet data:", error);
      }
    };

    fetchFleetsData();
  }, [id, routeState?.fleetdata]);

  return (
    <>
      <Helmet>
        <title>FLEETS REQUEST | EUROPE TOURS & TRAVELS</title>
      </Helmet>

      <main
        className={`container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row ${className}`}
      >
        <FleetsreqCard data={fleetsData[0]} />
      </main>

      <ToastContainer />
    </>
  );
};

export default FleetsRequest;
